// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"bfbf5f06","313":"41cccdc6","456":"321fa99e"}[chunkId] + ".chunk.css";
};